import "@Styles/mandate.css";
import React, { useEffect, useState, useRef } from "react";
import "react-circular-progressbar/dist/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import bellnotify from "../../../assets/bellnifify.png";
import bell from "../../../Images/NewUI/blackbell.png";
import { notifyVisitorEvent } from "../../../Redux/ApplyLoan/action";
import { fetchDashboardData } from "../../../Redux/Dashboard/action";
import { referandearndiraction } from "../../../Redux/Manual_Kyc_Details/action";
import { Loader } from "../../NewUI/Common/Loader";
import PreCloserTile from "../../NewUI/User/NewUser/SuperAppComponents/PreCloserLoan";
import UnderReview from "../../NewUI/User/NewUser/SuperAppComponents/UnderReview";
import Header from "../Common/Headerr";
import ToggleBar from "../DashBoardNew/ToggleBar";
import MmbFeatureCarousel from "./MmbFeatureCarousel";
import LoanMain from "./NewUser/SuperAppComponents/LoanMain";
import LoanReject from "./NewUser/SuperAppComponents/LoanReject";
import SuperApprepay from "./NewUser/SuperAppComponents/SuperApprepay";


function DashboardSlider() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  const user = useSelector((state) => state.user);
  const {
    loading,
    loanStatus: loanData,
    documentStatus: statusData,
    userDetails: personalInfo,
    credit,
    blocked: isblockeduser,
    cibilFlow,
    canApplyForLoan,
    hasReadNotification,
    precloserShow,
    hasLoanData,
  } = useSelector((state) => state.dashboard);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  const token = user?.User?.token || localStorage.getItem("gpay_token");

  const canApplyFromPersonalInfo = personalInfo?.can_apply_for_loan || false;

  useEffect(() => {
    localStorage.removeItem("loanAmount");
    localStorage.removeItem("loanReason");

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);

    const queryParams = new URLSearchParams(window.location.search);
    const isPerp = queryParams.get("isPerp");
    const isWebPerp = queryParams.get("webPerp");

    if (isPerp === "true" || isWebPerp) {
      handleReferandEarn();
    }

    dispatch(fetchDashboardData(token));

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, token]);

  useEffect(() => {
    if (
      !hasRedirected.current &&
      hasLoanData &&
      (!loanData?.loan_status || loanData?.loan_status === "PASSED")
    ) {
      hasRedirected.current = true;
      navigate("/dashboard_s");
    }
  }, [hasLoanData, loanData, navigate]);

  const handleNotificationredirection = () => {
    setTimeout(() => {
      window.location.href = "/notifications";
    }, 100);
  };

  const handleReferandEarn = () => {
    const payload = {
      event_name: "Interacted_SuperApp_Dashboard",
      event_body: { Platform: "m-site", "Clicked on": "PERP" },
    };
    notifyVisitorEvent(payload).catch(() => {});

    dispatch(referandearndiraction(token))
      .then((res) => {
        setTimeout(() => {
          window.location.href = res.data.url;
        }, 100);
      })
      .catch(() => {});
  };

  const handleReferandEarn2 = () => {
    const payload = {
      event_name: "Interacted_SuperApp_Dashboard",
      event_body: { Platform: "m-site", "Clicked on": "PERP_banner1" },
    };
    notifyVisitorEvent(payload).catch(() => {});

    dispatch(referandearndiraction(token))
      .then((res) => {
        setTimeout(() => {
          window.location.href = res.data.url;
        }, 100);
      })
      .catch(() => {});
  };

  return (
    <>
      <div className="flex_row justifycontentSpacebetn mt-16 loiandashoardheading">
        <Header documentStatus={statusData} />
        <span className="notify belldesign">
          <div className="flex" onClick={handleReferandEarn}>
            <div style={{ marginTop: "8px" }} onClick={handleNotificationredirection}>
              {hasReadNotification ? (
                <img src={bell} alt="img" width="27px" height="27px" />
              ) : (
                <img
                  src={bellnotify}
                  alt="img"
                  width="27px"
                  height="30px"
                  style={{ marginTop: "-3px", cursor: "pointer" }}
                />
              )}
            </div>
          </div>
        </span>
      </div>

      {loading && <Loader />}
      <div id="#" className="chatbot-container chatbot-container-max page-wrapper">
        <div>
          <div style={{ paddingLeft: "0px" }} className={!isLargeScreen ? "container " : ""}>
            <div style={{ position: "relative" }} className="cardbottomMargin aligncentrehere superappcardfix">
              {loading ? null : loanData?.loan_status === "DISBURSED" || loanData?.loan_status === "BALANCE_AMOUNT" ? (
                <SuperApprepay />
              ) : isblockeduser ? (
                <LoanReject />
              ) : hasLoanData && (loanData?.loan_status == null || loanData?.loan_status === "PASSED") ? (
                <LoanMain
                  userDetail={personalInfo}
                  loanStatusData={loanData}
                  documentStatus={statusData}
                  credit={credit}
                />
              ) : !canApplyFromPersonalInfo &&
                personalInfo?.usercredit?.length > 0 &&
                loanData?.loan_status !== null &&
                loanData?.loan_status !== "PASSED" &&
                loanData?.loan_status !== "DISBURSED" &&
                loanData?.loan_status !== "BALANCE_AMOUNT" ? (
                <UnderReview documentStatus={statusData} />
              ) : (
                <LoanMain
                  userDetail={personalInfo}
                  loanStatusData={loanData}
                  documentStatus={statusData}
                  credit={credit}
                />
              )}
              {!isblockeduser && <MmbFeatureCarousel />}
              <div style={{ opacity: 0 }}>{precloserShow && <PreCloserTile />}</div>
            </div>
            <div
              className={!isLargeScreen ? "fixofneperpdiv" : "fixofneperpdivnew"}
              onClick={handleReferandEarn2}
            />
            <br />
          </div>
          <br />
          <ToggleBar cibilFlow={cibilFlow} redirect={isblockeduser} documentStatus={statusData} />
        </div>
      </div>
    </>
  );
}

export default DashboardSlider;
